import Button from 'components/button';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import useForm from 'hooks/useForm';

const CreateCoupon = () => {
  const { postApi } = UseApi();
  const createCoupon = async () => {
    const res = await postApi(`coupons`, values);
    if (res?.data.message) {
      resetForm();
    }
  };

  const { values, handleChange, resetForm, handleSubmit } = useForm(
    {
      code: '',
      discount: '',
      expirationDate: '',
    },
    createCoupon,
  );

  return (
    <Card extra="p-4 mb-4  lg:m-auto flex flex-col gap-4">
      <Header>Create Coupon</Header>
      <InputField
        variant="auth"
        extra="mb-3"
        label="Coupon Code*"
        placeholder="Enter Coupon code"
        id="code"
        type="text"
        value={values.code}
        onChange={handleChange}
        name="code"
      />
      <InputField
        variant="auth"
        extra="mb-3"
        label="Discount Amount*"
        placeholder="Enter Dicount amount"
        id="discount"
        type="number"
        value={values.discount}
        onChange={handleChange}
        name="discount"
      />
      <InputField
        variant="auth"
        extra="mb-3"
        label="Expiration Date*"
        placeholder="Enter expiration date"
        id="expirationDate"
        type="date"
        value={values.expirationDate?.substring(0, 10)}
        onChange={handleChange}
        name="expirationDate"
      />
      <Button extraClasses="mx-auto" onClick={handleSubmit}>
        Create
      </Button>
    </Card>
  );
};

export default CreateCoupon;
